export enum EPHONE_PREFIXES {
  POLAND = '+48',
  TURKEY = '+90',
  BULGARIA = '+359',
  CROATIA = '+385',
  CZECH_REPUBLIC = '+420',
  SLOVAKIA = '+421'
}
